import React from "react";
import { motion } from "framer-motion";
import { sectionVariants, staggerContainer, itemVariants } from "../../constants/animations";
import { LANGUAGES, SOFT_SKILLS } from "./LanguagesAndSkills.constants";

const LanguagesAndSkills: React.FC = () => {
  return (
    <motion.section
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="py-20 px-6"
    >
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12">
          {/* Languages */}
          <div>
            <h2 className="text-3xl font-bold mb-8 gradient-text">
              Languages
            </h2>
            <div className="glass rounded-2xl p-6">
              {LANGUAGES.map((lang, i) => (
                <motion.div
                  key={lang.name}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ delay: i * 0.1 }}
                  viewport={{ once: true }}
                  className="mb-4 last:mb-0"
                >
                  <div className="flex justify-between mb-2">
                    <span className="font-medium text-white">
                      {lang.name}
                    </span>
                    <span className="text-slate-400 text-sm">
                      {lang.level}
                    </span>
                  </div>
                  <div className="h-2 bg-slate-700 rounded-full overflow-hidden">
                    <motion.div
                      initial={{ width: 0 }}
                      whileInView={{ width: `${lang.percentage}%` }}
                      transition={{ duration: 1, delay: i * 0.1 }}
                      viewport={{ once: true }}
                      className="h-full rounded-full bg-gradient-to-r from-blue-500 to-purple-500"
                    />
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Soft Skills */}
          <div>
            <h2 className="text-3xl font-bold mb-8 gradient-text">
              Soft Skills
            </h2>
            <motion.div
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="grid grid-cols-2 gap-4"
            >
              {SOFT_SKILLS.map((skill) => (
                <motion.div
                  key={skill.name}
                  variants={itemVariants}
                  whileHover={{ scale: 1.05 }}
                  className="glass rounded-xl p-4 flex items-center gap-3"
                >
                  <skill.icon className="text-2xl text-blue-400 flex-shrink-0" />
                  <span className="text-sm text-slate-300">{skill.name}</span>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default LanguagesAndSkills;
